<template>
  <div class="header">
    <f-top-app-bar
      title="Penelope"
      :img="logo"
    >
      <img slot="centerMobile" alt="logo" :src="logo">
      <template slot="right">
        <f-button text @click="onLogout">
          {{ menuText.disconnect }}
        </f-button>
        <f-top-app-bar-separator />
        <f-button text>
          {{ menuText.help }}
        </f-button>
        <f-top-app-bar-separator />
        <f-menu direction="bottom-end">
          <f-button slot="activator" text
                    icon="user"
                    trailicon="angle-down"
          >
            {{ username }}
          </f-button>
          <f-list-item :text="menuText.signOff" @click="onLogout" />
        </f-menu>
      </template>
      <template slot="rightMobile">
        <f-icon class="item" name="power-off" @click="onLogout" />
        <f-icon class="item" name="info" />
        <f-menu class="item" direction="bottom-end">
          <f-icon slot="activator" class="item" name="user" />
          <f-list-item :text="menuText.signOff" @click="onLogout" />
        </f-menu>
      </template>
    </f-top-app-bar>
    <f-menu-horizontal
      ref="menuHorizontalRef"
      class="f-menu-horizontal"
      :items-menu="itemsMenu"
    />
    <view-tabs v-show="useTabs" :name="tabName" />
  </div>
</template>
<script>
import {
  FTopAppBar,
  FTopAppBarSeparator,
  FMenuHorizontal,
  FMenu,
  FButton,
  FIcon,
  FListItem
} from 'fwkc4-vue'
import ViewTabs from '@/components/viewTabs/ViewTabs.vue'
import logoHorizontal from '../assets/images/LOGO_EURECA_LONGUEUR_DEGRADE_NOIR.png'
import i18n from '@/i18n'
import env from '@/services/environment'
import { loadUserAccess, usersDetails, loadUserAccessPermissions } from '@/utils/userAccess'
import { accessVerification } from '@/utils/utils'

import store from '@/store'
import { $bus } from '@/main'
import getUserAccessPermissionsData from '@/services/userAccessData/getUserAccessPermissionsData.service'
import getCauseOfDisputeData from '@/services/penaltyMaster/getCauseOfDisputeData.service'
import getReportsDetails from '@/services/reports/getReportsDetails.service'
import { DIALOG_CONFIRM_CREATE, DIALOG_ERROR } from '@/components/dialogs'
import { TokenInfoService } from '@/services/auth/common/tokenInfo'
import { LogOutService } from '@/services/auth/common/logOutService'
import idleScreenMixin from '@/mixins/idleScreenMixin'
export default {
  name: 'MenuComplete',
  components: {
    FTopAppBar,
    FTopAppBarSeparator,
    FMenuHorizontal,
    FButton,
    FIcon,
    FMenu,
    FListItem,
    ViewTabs
  },
  // props: {
  //   username: {
  //     type: String,
  //     default: ''
  //   }
  // },
  mixins: [idleScreenMixin],
  data () {
    return {
      tabName: null,
      logo: logoHorizontal,
      openDrawerData: true,
      itemsMenu: [],
      userAcessData: null,
      userType: null,
      userRole: null,
      countryNotVMI: null,
      menuText: i18n.t('header'),
      username: null
    }
  },
  computed: {
    useTabs () {
      return env.getEnvVariable('VUE_APP_USE_TABS').toUpperCase() === 'TRUE'
    },
    userActions () {
      return this.$store.getters['user/getUser'].getActions()
    },
    userName () {
      const user = store.getters['user/getUser']
      return user.getUsername()
    }
  },
  mounted () {
    this.trackUserActivness()
    loadUserAccess('MenuComplete')
    $bus.$on('userAccessResponse', (name) => {
      this.userAcessData = this.$store.getters['UsersAccess/UsersAccess']
      if (this.userAcessData) {
        this.userType = this.userAcessData[0].userDetails.userType
        this.userRole = this.userAcessData[0].userDetails.userRole
        const countryList = []
        this.userAcessData[0].countryAccessInfo.map((item) => {
          countryList.push(item.countryData)
        })
        this.countryNotVMI = countryList.filter((country) => country.vmi !== 1)
        this.getAuthurizationData()
        this.getCauseOfDisputeList(countryList)
        if (name !== 'AdminView') {
          this.goTo(i18n.t('menu.penaltyMaster'), '/')
        }
        this.userDetails = usersDetails()
        this.username = this.userDetails?.username
      }
      // this.$store.dispatch('ui/hideMask')
    })
    $bus.$on('logout', () => {
      this.$nextTick(async () => {
        await this.onLogout()
      })
    })
    this.$root.$on('penaltyCreateTab', (data) => {
      this.goTo(data.name, data.route)
    })
  },
  beforeDestroy () {
    this.$root.$off('penaltyCreateTab')
  },
  methods: {
    getAuthurizationData () {
      getUserAccessPermissionsData().then((result) => {
        if (result.status === 200) {
          store.dispatch('UsersAccess/setUsersAccessPermissions', result.data)
          // store.dispatch('ui/hideMask')
          this.itemsMenu = this.getMenuItems()
          TokenInfoService.buildExpirationDate()
        } else {
          store.dispatch('UsersAccess/setUsersAccessPermissions', [])
          store.dispatch('ui/hideMask')
        }
      })
    },
    async getLoadUserAccess () {
      loadUserAccess()
    },
    async getLoadUserAccessPermissions () {
      loadUserAccessPermissions()
    },
    goTo (name, route) {
      this.tabName = { name, route }
      if (this.$router.currentRoute.path !== route) {
        this.$router.push(route)
        const currentComponent = this.$router.options.routes.find(item =>
          item.path === route
        ).name
        this.$store.dispatch('ui/addOpenedTab', currentComponent)
      }
    },
    getMenuItems () {
      const menus = []
      menus.push(this.getPenaltyMasterMenuItems())
      // }
      if (accessVerification('Penalty Creation', 'r008')) {
        menus.push(this.getPenaltyCreationMenuItems())
      }
      // Start: Order Management Menu
      if (accessVerification('Order Management', 'r032') && (this.userType === 'crf' || (this.userType === 'eur' && this.userRole === 'admin')) && (this.countryNotVMI.length > 0)) {
        const orderSearch = {
          name: i18n.t('menu.orders'),
          items: this.getOrderItemItems()
        }
        menus.push(orderSearch)
      }
      // End: Order Management Menu

      if (accessVerification('Penalty Management', 'r039')) {
        menus.push(this.getPenaltyManagementMenuItems())
      }

      if (accessVerification('Documentation', 'r044')) {
        menus.push(this.getDocumentationMenuItems())
      }
      if (accessVerification('Parameters', 'r050')) {
        menus.push(this.getParametersItems())
      }

      if (accessVerification('Administration', 'r048')) {
        menus.push(this.getAdminMenuItems())
      }
      return menus
    },
    getPenaltyMasterMenuItems () {
      return {
        name: i18n.t('menu.penaltyMaster'),
        action: () => this.goTo(i18n.t('menu.penaltyMaster'), '/')
      }
    },
    getPenaltyCreationMenuItems () {
      return {
        name: i18n.t('menu.penaltyCreate'),
        action: () => this.goTo(i18n.t('menu.penaltyCreate'), '/penaltyCreate')
      }
    },
    getOrderItemItems () {
      const orderItem = []

      // Order Search sub menu
      if (this.userType === 'crf' || (this.userType === 'eur' && this.userRole === 'admin')) {
        const orderSearch_orderSearch = {
          name: i18n.t('submenu.orderManagement.orderSearch'),
          action: () => this.goTo(i18n.t('submenu.orderManagement.orderSearch'), '/Orders')
        }
        orderItem.push(orderSearch_orderSearch)
      }
      // Order file upload sub menu
      if ((this.userType === 'crf' && (this.userRole === 'admin' || this.userRole === 'key')) || (this.userType === 'eur' && this.userRole === 'admin')) {
        const orderSearch_orderFileUpload = {
          name: i18n.t('submenu.orderManagement.orderFileUpload'),
          action: () => this.goTo(i18n.t('submenu.orderManagement.orderFileUpload'), '/OrderManagementSearchSLP')
        }
        orderItem.push(orderSearch_orderFileUpload)
      }
      return orderItem
    },
    getPenaltyManagementMenuItems () {
      return {
        name: i18n.t('menu.penaltyManagement'), // As per PMT Users et rights GLOBAL GRID V1 excel made changes.
        action: () => this.goTo(i18n.t('menu.penaltyManagement'), '/PenaltyManagementSearch')
      }
    },
    getDocumentationMenuItems () {
      const consultatioItem = []
      if (accessVerification('Documentation', 'r045')) {
        const consultationSup = {
          name: i18n.t('submenu.documentation.supplierDocumentation'),
          action: () => this.goTo(i18n.t('submenu.documentation.supplierDocumentation'), '/DocumentationSupplier')
        }
        const consultationWarehouse = {
          name: i18n.t('submenu.documentation.warehouseDocumentation'),
          action: () => this.goTo(i18n.t('submenu.documentation.warehouseDocumentation'), '/DocumentationWarehouse')
        }
        consultatioItem.push(consultationSup)
        consultatioItem.push(consultationWarehouse)
      }
      const documentation = {
        name: i18n.t('menu.documentation'),
        items: consultatioItem
      }

      if (accessVerification('Documentation', 'r046')) {
        const reports = {
          name: i18n.t('submenu.documentation.reports'),
          items: [
            {
              name: i18n.t('submenu.documentation.reportsItems.agreementNotes'),
              action: () => this.getReportsData('agreementNotes')
            },
            {
              name: i18n.t('submenu.documentation.reportsItems.currentPenalties'),
              action: () => this.getReportsData('currentPenalties')
            },
            {
              name: i18n.t('submenu.documentation.reportsItems.nonAgreement'),
              action: () => this.getReportsData('nonAgreement')
            },
            {
              name: i18n.t('submenu.documentation.reportsItems.closedPenalties'),
              action: () => this.getReportsData('closedPenalties')
            }
          ]
        }
        documentation.items.push(reports)
      }
      return documentation
    },
    getParametersItems () {
      return {
        name: i18n.t('menu.parameters'),
        action: () => this.goTo(i18n.t('menu.parameters'), '/Parameters')
      }
    },
    getAdminMenuItems () {
      // ----Start: Repository Submenus
      const repositoryItems = []
      if (this.userType !== 'supp') {
        const admin_country = {
          name: i18n.t('submenu.administration.repository.countryAdministration'),
          action: () => this.goTo(i18n.t('submenu.administration.repository.countryAdministration'), '/AdministrationCountry')
        }
        repositoryItems.push(admin_country)
      }

      const supplierAdministration = {
        name: i18n.t('submenu.administration.repository.supplierAdministration'),
        action: () => this.goTo(i18n.t('submenu.administration.repository.supplierAdministration'), '/AdministrationSupplier')
      }
      repositoryItems.push(supplierAdministration)

      const warehouseAdministration = {
        name: i18n.t('submenu.administration.repository.warehouseAdministration'),
        action: () => this.goTo(i18n.t('submenu.administration.repository.warehouseAdministration'), '/AdministrationWarehouse')
      }
      repositoryItems.push(warehouseAdministration)

      if (this.userType !== 'supp') {
        const penaltyGrid = {
          name: i18n.t('submenu.administration.repository.penaltyGrid'),
          action: () => this.goTo(i18n.t('submenu.administration.repository.penaltyGrid'), '/penaltyGrid')
        }
        repositoryItems.push(penaltyGrid)
        const slGrid = {
          name: i18n.t('submenu.administration.repository.slGrid'),
          action: () => this.goTo(i18n.t('submenu.administration.repository.slGrid'), '/SlGridSearch')
        }
        repositoryItems.push(slGrid)
      }
      const repository = {
        name: i18n.t('submenu.administration.repositoryItem'),
        items: repositoryItems
      }
      // ---- End : Repository Submenus
      const userItems = []

      const users = {
        name: i18n.t('submenu.administration.users.title'),
        items: userItems
      }
      const userManagement = {
        name: i18n.t('submenu.administration.users.userManagement'),
        action: () => this.goTo(i18n.t('submenu.administration.users.title'), '/users')
      }
      const userPermission = {
        name: i18n.t('submenu.administration.users.permission'),
        action: () => this.goTo(i18n.t('submenu.administration.users.permission'), '/permission')
      }
      userItems.push(userManagement)
      userItems.push(userPermission)
      const administration = {
        name: i18n.t('menu.administration'),
        items: [repository, users]
      }
      return administration
    },
    openDrawer () {
      this.openDrawerData = true
    },
    closeDrawer () {
      this.openDrawerData = false
    },
    onLogout () {
      LogOutService.logoutApp()
    },
    onResize (event) {
      this.$emit('resize', event)
    },
    onCloseTab (componentName) {
      this.$emit('closeTab', componentName)
    },
    getLogoutUrl () {
      const aToken = JSON.parse(sessionStorage.getItem('accessInfo'))
      const logoutBaseUrl = env.getEnvVariable('VUE_APP_SSO_LOGOUT_URL')
      const idTokenHint = `?id_token_hint=${aToken.accessToken}`
      const clientId = `&client_id=${env.getEnvVariable('VUE_APP_APP_CODE')}`

      return logoutBaseUrl.concat(idTokenHint).concat(clientId)
      // return `https://ppd.np.idp.carrefour.com:443/am/oauth2/realms/root/realms/sso/connect/endSession?id_token_hint=${aToken.accessToken}&client_id=openid_penelope_ppd`
    },
    getReportsData (type) {
      DIALOG_CONFIRM_CREATE.props.buttonLabelAffirmative = this.$i18n.t('buttons.ok')
      DIALOG_CONFIRM_CREATE.props.buttonLabelNegative = this.$i18n.t('buttons.cancel')
      this.getTitleAndTextOfPopup(type)
      DIALOG_CONFIRM_CREATE.props.class = 'centerModalText'
      this.$store.dispatch('ui/openDialog', Object.assign({}, DIALOG_CONFIRM_CREATE, {
        props: {
          ...DIALOG_CONFIRM_CREATE.props,
          buttonActionAffirmative: () => {
            this.downloadEvent(type)
          }
        }
      }))
    },
    downloadEvent (type) {
      this.$store.dispatch('ui/showMask')
      try {
        const request = {
          isAgreementNote: type === 'agreementNotes',
          isCurrent: type === 'currentPenalties',
          isNonAgreement: type === 'nonAgreement',
          isClosed: type === 'closedPenalties'
        }
        getReportsDetails(request).then((response) => {
          if (response.status === 200) {
            for (let i = 0; i < response.data.length; i++) {
              this.generateExcel(response.data[i], type, i + 1)
            }
            this.$store.dispatch('ui/hideMask')
          }
        }).catch(error => {
          console.log(error)
          if (error.response.status === 404) {
            this.$store.dispatch('ui/hideMask')
            DIALOG_ERROR.props.title = this.$i18n.t('dialogs.title.error')
            DIALOG_ERROR.props.text = error.response.data.message
            this.$store.dispatch('ui/openDialog', DIALOG_ERROR)
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    generateExcel (data, type, i) {
      const stream = data.stream
      window.URL = window.URL || window.webkitURL
      const sampleBytes = this.base64ToArrayBuffer(stream)
      const blob = new Blob([sampleBytes], { type: 'application/vnd.ms-excel' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.href = url
      a.download = this.$i18n.t('submenu.documentation.reportsItems.' + type) + ' -' + i + '.xlsx'
      a.click()
    },
    base64ToArrayBuffer (base64) {
      const binaryString = window.atob(base64)
      const binaryLen = binaryString.length
      const bytes = new Uint8Array(binaryLen)
      for (let i = 0; i < binaryLen; i++) {
        const ascii = binaryString.charCodeAt(i)
        bytes[i] = ascii
      }
      return bytes
    },
    getTitleAndTextOfPopup (type) {
      if (type === 'agreementNotes') {
        DIALOG_CONFIRM_CREATE.props.title = this.$i18n.t('dialogs.title.agreementNotes')
        DIALOG_CONFIRM_CREATE.props.text = this.$i18n.t('dialogs.text.agreementNotes')
      }
      if (type === 'currentPenalties') {
        DIALOG_CONFIRM_CREATE.props.title = this.$i18n.t('dialogs.title.currentPenalties')
        DIALOG_CONFIRM_CREATE.props.text = this.$i18n.t('dialogs.text.currentPenalties')
      }
      if (type === 'nonAgreement') {
        DIALOG_CONFIRM_CREATE.props.title = this.$i18n.t('dialogs.title.nonAgreement')
        DIALOG_CONFIRM_CREATE.props.text = this.$i18n.t('dialogs.text.nonAgreement')
      }
      if (type === 'closedPenalties') {
        DIALOG_CONFIRM_CREATE.props.title = this.$i18n.t('dialogs.title.closedPenalties')
        DIALOG_CONFIRM_CREATE.props.text = this.$i18n.t('dialogs.text.closedPenalties')
      }
    },
    async getCauseOfDisputeList (countryList = []) {
      const filterFRCountry = countryList?.filter(row => row.countryId === 'FR')
      const isValidUser = filterFRCountry?.length > 0
      if (isValidUser) {
        await getCauseOfDisputeData().then((result) => {
          let codList = []
          let sectorList = []
          if (result?.status === 200) {
            const data = result?.content?.data
            codList = data?.length > 0 ? data[0]?.causeOfDispute : []
            sectorList = data?.length > 0 ? data[0]?.sectorList : []
          }
          store.dispatch('UsersAccess/setCauseOfDisputeList', (codList || []))
          store.dispatch('UsersAccess/setFranceSectorList', (sectorList || []))
        }).catch(error => {
          console.log(error)
        }).finally(() => {
          store.dispatch('ui/hideMask')
        })
      } else {
        store.dispatch('UsersAccess/setFranceSectorList', [])
        store.dispatch('UsersAccess/setCauseOfDisputeList', [])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.f-menu-horizontal {
  margin-top: 50px;
}
</style>
